import React from 'react';

const PageBanner = (props) => {
  return (
    <>
        <div className='page-banner'>
           <div className='banner-img'>
                <p className='msg-line-1'>{props.msgLine1}</p>
                <h3 className='msg-line-2'>{props.msgLine2}</h3>
                <p className='msg-line-3'>{props.msgLine3}</p>
                {props.cta? <a href='#pricing' type='button' className='btn btn-dark'>Get Quote</a>:""}
                {props.bannerImg1?<img src={props.bannerImg1} className='banner-img-1'/>:""}
                {props.bannerImg1?<img src={props.bannerImg2} className='banner-img-2'/>:""}
           
           </div>
        </div>
    </>
  )
}

export default PageBanner